import { render, staticRenderFns } from "./IdCardNumber.vue?vue&type=template&id=5070eadc&scoped=true"
import script from "./IdCardNumber.vue?vue&type=script&lang=js"
export * from "./IdCardNumber.vue?vue&type=script&lang=js"
import style0 from "./IdCardNumber.vue?vue&type=style&index=0&id=5070eadc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5070eadc",
  null
  
)

export default component.exports